module.exports = __webpack_public_path__ + "portal-static/img/rz.c743079a.png";